'use client';

import { IFooterProps, Layout } from '../../../../components/layout/Layout';
import { CatalogPage } from '../../../../components/pages/catalog-events/catalog';
import { Category } from '../../../../models/categories';
import { Action, City } from '../../../../models';
import { ActionCategory } from '../../../../models/action';
import { FilterQuery, ISortFilter } from '../../../../models/filters';
import { PromoCardTypes } from '../../../../models/promo-card';

type IPageComponentProps = {
  categoriesForHeader: Category[];
  categories: ActionCategory[];
  currentCity: City;
  eventsList: {
    next: string | null;
    count: number;
    results: (Action | PromoCardTypes)[];
  };
  footerProps: IFooterProps;
  gorbiletRekomenduet: {
    actions: Action[];
    slug?: string;
  };
  initialSeoCategory?: Category | null;
  sortTypes: ISortFilter[];
  startQuery: FilterQuery;
};

export function PageComponent({
  currentCity,
  eventsList,
  categories,
  sortTypes,
  startQuery,
  initialSeoCategory,
  categoriesForHeader,
  gorbiletRekomenduet,
  footerProps,
}: IPageComponentProps) {
  let categoryTitle = '';
  categories.forEach((category: any) => {
    if (category.id === startQuery.filters.categories.category) {
      if (startQuery.filters.categories.subcategories.length === 1) {
        categoryTitle = category.children.find(
          (childrenCategory: any) =>
            childrenCategory.id ===
            startQuery.filters.categories.subcategories[0]
        ).title;
      } else {
        categoryTitle = category.title;
      }
    }
  });

  return (
    <Layout
      footerProps={footerProps}
      currentCity={currentCity}
      categoriesForHeader={categoriesForHeader}
    >
      <CatalogPage
        initialSeoCategory={initialSeoCategory}
        productMicrodata={
          initialSeoCategory && initialSeoCategory.event_count ? (
            <div
              css={{ display: 'none' }}
              itemScope
              itemType='https://schema.org/Product'
            >
              <meta itemProp='name' content={categoryTitle} />
              <div
                itemType='https://schema.org/AggregateOffer'
                itemScope
                itemProp='offers'
              >
                {typeof initialSeoCategory.event_count === 'number' && (
                  <meta
                    content={`${initialSeoCategory.event_count}`}
                    itemProp='offerCount'
                  />
                )}
                {typeof initialSeoCategory.event_max_price === 'number' && (
                  <meta
                    content={`${initialSeoCategory.event_max_price}`}
                    itemProp='highPrice'
                  />
                )}
                {typeof initialSeoCategory.event_min_price === 'number' && (
                  <meta
                    content={`${initialSeoCategory.event_min_price}`}
                    itemProp='lowPrice'
                  />
                )}
                <meta content='RUB' itemProp='priceCurrency' />
              </div>
              {typeof initialSeoCategory.event_average_rating === 'number' &&
                initialSeoCategory.event_average_rating > 0 && (
                  <div
                    itemType='https://schema.org/AggregateRating'
                    itemScope
                    itemProp='aggregateRating'
                  >
                    {typeof initialSeoCategory.event_total_views_count ===
                      'number' && (
                      <meta
                        content={`${initialSeoCategory.event_total_views_count}`}
                        itemProp='reviewCount'
                      />
                    )}
                    {typeof initialSeoCategory.event_min_rating ===
                      'number' && (
                      <meta
                        content={`${initialSeoCategory.event_min_rating}`}
                        itemProp='worstRating'
                      />
                    )}
                    {typeof initialSeoCategory.event_max_rating ===
                      'number' && (
                      <meta
                        content={`${initialSeoCategory.event_max_rating}`}
                        itemProp='bestRating'
                      />
                    )}
                    {typeof initialSeoCategory.event_average_rating ===
                      'number' && (
                      <meta
                        content={`${initialSeoCategory.event_average_rating}`}
                        itemProp='ratingValue'
                      />
                    )}
                  </div>
                )}
            </div>
          ) : null
        }
        currentCity={currentCity}
        eventsList={eventsList}
        categories={categories}
        sortTypes={sortTypes}
        gorbiletRekomenduet={gorbiletRekomenduet}
        startQuery={startQuery}
      />
    </Layout>
  );
}
